function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#fff",
    d: "M 127.5,-0.5 C 137.5,-0.5 147.5,-0.5 157.5,-0.5C 168.328,11.161 179.661,22.3276 191.5,33C 183.173,33.4997 174.84,33.6664 166.5,33.5C 162.154,33.6657 157.821,33.499 153.5,33C 142.328,22.9944 131.661,12.4944 121.5,1.5C 123.626,0.951844 125.626,0.285178 127.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#fff",
    d: "M 157.5,-0.5 C 170.167,-0.5 182.833,-0.5 195.5,-0.5C 206.938,10.4374 218.272,21.604 229.5,33C 225.312,33.1762 221.312,33.6762 217.5,34.5C 200.5,34.5 183.5,34.5 166.5,34.5C 166.5,34.1667 166.5,33.8333 166.5,33.5C 174.84,33.6664 183.173,33.4997 191.5,33C 179.661,22.3276 168.328,11.161 157.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#fff",
    d: "M 195.5,-0.5 C 208.167,-0.5 220.833,-0.5 233.5,-0.5C 244.938,10.4374 256.272,21.604 267.5,33C 265.618,33.1981 263.952,33.6981 262.5,34.5C 247.5,34.5 232.5,34.5 217.5,34.5C 221.312,33.6762 225.312,33.1762 229.5,33C 218.272,21.604 206.938,10.4374 195.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fff",
    d: "M 233.5,-0.5 C 248.5,-0.5 263.5,-0.5 278.5,-0.5C 289.86,11.5271 301.527,23.1937 313.5,34.5C 296.5,34.5 279.5,34.5 262.5,34.5C 263.952,33.6981 265.618,33.1981 267.5,33C 256.272,21.604 244.938,10.4374 233.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fff",
    d: "M 278.5,-0.5 C 291.167,-0.5 303.833,-0.5 316.5,-0.5C 327.328,11.161 338.661,22.3276 350.5,33C 353.036,33.1862 355.369,33.6862 357.5,34.5C 342.833,34.5 328.167,34.5 313.5,34.5C 301.527,23.1937 289.86,11.5271 278.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#fff",
    d: "M 316.5,-0.5 C 329.167,-0.5 341.833,-0.5 354.5,-0.5C 367.938,12.4375 381.272,25.6042 394.5,39C 394.272,39.3988 393.938,39.5654 393.5,39.5C 389.371,37.5123 385.038,36.0123 380.5,35C 372.841,34.5003 365.174,34.3336 357.5,34.5C 355.369,33.6862 353.036,33.1862 350.5,33C 338.661,22.3276 327.328,11.161 316.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#fff",
    d: "M 354.5,-0.5 C 364.833,-0.5 375.167,-0.5 385.5,-0.5C 417.446,6.61074 437.946,25.9441 447,57.5C 448.326,68.7899 448.826,80.1233 448.5,91.5C 436.035,79.5353 423.702,67.3687 411.5,55C 410.563,54.3083 409.897,54.475 409.5,55.5C 405.167,49.1667 399.833,43.8333 393.5,39.5C 393.938,39.5654 394.272,39.3988 394.5,39C 381.272,25.6042 367.938,12.4375 354.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#fff",
    d: "M 121.5,1.5 C 131.661,12.4944 142.328,22.9944 153.5,33C 157.821,33.499 162.154,33.6657 166.5,33.5C 166.5,33.8333 166.5,34.1667 166.5,34.5C 154.829,34.3335 143.162,34.5001 131.5,35C 126.607,36.3514 121.94,38.1847 117.5,40.5C 109.088,33.5932 101.088,26.0932 93.5,18C 92.552,17.5172 91.552,17.3505 90.5,17.5C 99.2352,9.29754 109.569,3.9642 121.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#fff",
    d: "M 90.5,17.5 C 91.552,17.3505 92.552,17.5172 93.5,18C 101.088,26.0932 109.088,33.5932 117.5,40.5C 109.54,46.1187 103.873,53.452 100.5,62.5C 92.3646,53.8385 83.8646,45.5051 75,37.5C 74.6174,38.056 74.1174,38.3893 73.5,38.5C 77.4906,30.2095 83.1573,23.2095 90.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fff",
    d: "M 100.5,62.5 C 99.6084,74.4739 99.2751,86.4739 99.5,98.5C 87.8867,87.2216 76.22,75.8882 64.5,64.5C 65.926,55.2197 68.926,46.553 73.5,38.5C 74.1174,38.3893 74.6174,38.056 75,37.5C 83.8646,45.5051 92.3646,53.8385 100.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fff",
    d: "M 448.5,91.5 C 448.5,105.833 448.5,120.167 448.5,134.5C 447.686,132.369 447.186,130.036 447,127.5C 436.267,116.265 425.101,105.598 413.5,95.5C 413.666,86.4938 413.5,77.4938 413,68.5C 412.133,64.0684 410.966,59.7351 409.5,55.5C 409.897,54.475 410.563,54.3083 411.5,55C 423.702,67.3687 436.035,79.5353 448.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#fff",
    d: "M 64.5,64.5 C 76.22,75.8882 87.8867,87.2216 99.5,98.5C 99.5,110.167 99.5,121.833 99.5,133.5C 98.8826,133.611 98.3826,133.944 98,134.5C 86.9651,123.298 75.7984,112.298 64.5,101.5C 64.5,89.1667 64.5,76.8333 64.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#fff",
    d: "M 285.5,87.5 C 313.835,115.835 342.502,143.835 371.5,171.5C 375.282,184.99 376.616,198.657 375.5,212.5C 363.172,200.339 350.672,188.339 338,176.5C 337.617,177.056 337.117,177.389 336.5,177.5C 326.468,150.801 308.135,132.468 281.5,122.5C 281.631,121.761 281.464,121.094 281,120.5C 268.938,108.271 256.772,96.2708 244.5,84.5C 258.336,82.9255 272.003,83.9255 285.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#fff",
    d: "M 244.5,84.5 C 256.772,96.2708 268.938,108.271 281,120.5C 281.464,121.094 281.631,121.761 281.5,122.5C 268.363,118.858 255.029,117.858 241.5,119.5C 232.473,109.806 223.14,100.473 213.5,91.5C 223.339,87.4593 233.672,85.126 244.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.96
    },
    fill: "#fff",
    d: "M 285.5,87.5 C 328.992,100.325 357.658,128.325 371.5,171.5C 342.502,143.835 313.835,115.835 285.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 213.5,91.5 C 223.14,100.473 232.473,109.806 241.5,119.5C 230.647,121.9 220.314,125.9 210.5,131.5C 200.859,123.86 192.526,115.526 185.5,106.5C 193.903,99.9624 203.236,94.9624 213.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 413.5,95.5 C 425.101,105.598 436.267,116.265 447,127.5C 447.186,130.036 447.686,132.369 448.5,134.5C 448.5,144.833 448.5,155.167 448.5,165.5C 437.135,154.134 425.469,143.134 413.5,132.5C 413.5,120.167 413.5,107.833 413.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#fff",
    d: "M 64.5,101.5 C 75.7984,112.298 86.9651,123.298 98,134.5C 98.3826,133.944 98.8826,133.611 99.5,133.5C 99.6368,148.181 99.3035,162.848 98.5,177.5C 86.9908,166.593 75.3242,155.926 63.5,145.5C 64.3941,130.855 64.7275,116.188 64.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#fff",
    d: "M 185.5,106.5 C 192.526,115.526 200.859,123.86 210.5,131.5C 203.271,136.387 196.604,142.054 190.5,148.5C 183.391,142.564 176.391,136.397 169.5,130C 167.536,128.549 166.203,126.716 165.5,124.5C 171.246,117.418 177.913,111.418 185.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fff",
    d: "M 165.5,124.5 C 166.203,126.716 167.536,128.549 169.5,130C 176.391,136.397 183.391,142.564 190.5,148.5C 184.24,156.09 179.24,164.423 175.5,173.5C 167.167,164.5 158.5,155.833 149.5,147.5C 153.604,138.952 158.937,131.286 165.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 413.5,132.5 C 425.469,143.134 437.135,154.134 448.5,165.5C 448.5,177.833 448.5,190.167 448.5,202.5C 447.698,203.952 447.198,205.618 447,207.5C 435.661,196.994 424.495,186.328 413.5,175.5C 413.5,161.167 413.5,146.833 413.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#fff",
    d: "M 303.5,222.5 C 281.526,201.528 259.526,180.528 237.5,159.5C 242.177,143.992 251.844,139.825 266.5,147C 269.106,148.938 270.939,151.438 272,154.5C 272.5,165.495 272.667,176.495 272.5,187.5C 283.172,187.333 293.839,187.5 304.5,188C 315.952,192.409 319.785,200.576 316,212.5C 313.659,218.09 309.492,221.424 303.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#fff",
    d: "M 63.5,145.5 C 75.3242,155.926 86.9908,166.593 98.5,177.5C 98.5,189.833 98.5,202.167 98.5,214.5C 86.5313,203.866 74.8647,192.866 63.5,181.5C 63.5,169.5 63.5,157.5 63.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#fff",
    d: "M 149.5,147.5 C 158.5,155.833 167.167,164.5 175.5,173.5C 172.321,183.396 170.321,193.396 169.5,203.5C 159.092,193.758 149.092,183.758 139.5,173.5C 141.194,164.127 144.527,155.46 149.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#fff",
    d: "M 237.5,159.5 C 259.526,180.528 281.526,201.528 303.5,222.5C 293.167,222.5 282.833,222.5 272.5,222.5C 272.5,224.833 272.5,227.167 272.5,229.5C 258.341,216.237 244.341,202.737 230.5,189C 227.964,188.814 225.631,188.314 223.5,187.5C 228.167,187.5 232.833,187.5 237.5,187.5C 237.5,178.167 237.5,168.833 237.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fff",
    d: "M 139.5,173.5 C 149.092,183.758 159.092,193.758 169.5,203.5C 172.237,250.068 196.237,278.901 241.5,290C 247.465,290.963 253.465,291.463 259.5,291.5C 269.105,300.604 278.605,309.937 288,319.5C 288.464,320.094 288.631,320.761 288.5,321.5C 274.644,325.708 260.644,327.042 246.5,325.5C 249.97,325.29 249.97,324.123 246.5,322C 209.696,286.863 173.196,251.363 137,215.5C 136.617,216.056 136.117,216.389 135.5,216.5C 133.959,201.78 135.292,187.446 139.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#fff",
    d: "M 413.5,175.5 C 424.495,186.328 435.661,196.994 447,207.5C 447.198,205.618 447.698,203.952 448.5,202.5C 448.5,217.167 448.5,231.833 448.5,246.5C 436.833,235.167 425.167,223.833 413.5,212.5C 413.5,200.167 413.5,187.833 413.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 375.5,212.5 C 375.274,223.295 373.274,233.628 369.5,243.5C 360.134,234.133 350.468,225.133 340.5,216.5C 341.716,203.334 340.382,190.334 336.5,177.5C 337.117,177.389 337.617,177.056 338,176.5C 350.672,188.339 363.172,200.339 375.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fff",
    d: "M 63.5,181.5 C 74.8647,192.866 86.5313,203.866 98.5,214.5C 98.5,227.167 98.5,239.833 98.5,252.5C 86.8333,241.167 75.1667,229.833 63.5,218.5C 63.5,206.167 63.5,193.833 63.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#fff",
    d: "M 223.5,187.5 C 225.631,188.314 227.964,188.814 230.5,189C 244.341,202.737 258.341,216.237 272.5,229.5C 272.945,238.94 272.445,248.274 271,257.5C 265.722,264.928 258.555,267.428 249.5,265C 244.427,263.594 240.927,260.428 239,255.5C 237.594,244.564 237.094,233.564 237.5,222.5C 226.828,222.667 216.161,222.5 205.5,222C 196.048,217.933 192.215,210.767 194,200.5C 195.5,193.667 199.667,189.5 206.5,188C 212.157,187.501 217.824,187.334 223.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fff",
    d: "M 413.5,212.5 C 425.167,223.833 436.833,235.167 448.5,246.5C 448.5,256.833 448.5,267.167 448.5,277.5C 447.698,278.952 447.198,280.618 447,282.5C 436.637,271.803 425.971,261.47 415,251.5C 414.802,253.382 414.302,255.048 413.5,256.5C 413.5,241.833 413.5,227.167 413.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#fff",
    d: "M 246.5,325.5 C 204.091,321.239 171.925,300.905 150,264.5C 141.833,249.5 137,233.5 135.5,216.5C 136.117,216.389 136.617,216.056 137,215.5C 173.196,251.363 209.696,286.863 246.5,322C 249.97,324.123 249.97,325.29 246.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 340.5,216.5 C 350.468,225.133 360.134,234.133 369.5,243.5C 366.678,254.142 362.011,263.809 355.5,272.5C 346.527,264.862 337.86,256.862 329.5,248.5C 334.764,238.375 338.43,227.708 340.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fff",
    d: "M 63.5,218.5 C 75.1667,229.833 86.8333,241.167 98.5,252.5C 98.5,264.833 98.5,277.167 98.5,289.5C 87.1353,278.134 75.4687,267.134 63.5,256.5C 63.5,243.833 63.5,231.167 63.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#fff",
    d: "M 329.5,248.5 C 337.86,256.862 346.527,264.862 355.5,272.5C 350.772,279.95 345.105,286.617 338.5,292.5C 336.745,291.928 335.078,291.094 333.5,290C 326.632,282.964 319.632,276.131 312.5,269.5C 315.462,266.036 318.629,262.703 322,259.5C 324.523,255.767 327.023,252.101 329.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#fff",
    d: "M 448.5,277.5 C 448.5,291.833 448.5,306.167 448.5,320.5C 437.024,309.269 425.358,298.269 413.5,287.5C 413.5,277.167 413.5,266.833 413.5,256.5C 414.302,255.048 414.802,253.382 415,251.5C 425.971,261.47 436.637,271.803 447,282.5C 447.198,280.618 447.698,278.952 448.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#fff",
    d: "M 63.5,256.5 C 75.4687,267.134 87.1353,278.134 98.5,289.5C 98.5,303.5 98.5,317.5 98.5,331.5C 86.2542,321.593 74.5875,310.926 63.5,299.5C 63.5,285.167 63.5,270.833 63.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#fff",
    d: "M 312.5,269.5 C 319.632,276.131 326.632,282.964 333.5,290C 335.078,291.094 336.745,291.928 338.5,292.5C 331.779,299.696 324.112,305.696 315.5,310.5C 315.631,309.761 315.464,309.094 315,308.5C 306.932,299.929 298.432,291.929 289.5,284.5C 297.642,280.26 305.309,275.26 312.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#fff",
    d: "M 289.5,284.5 C 298.432,291.929 306.932,299.929 315,308.5C 315.464,309.094 315.631,309.761 315.5,310.5C 307.055,315.537 298.055,319.204 288.5,321.5C 288.631,320.761 288.464,320.094 288,319.5C 278.605,309.937 269.105,300.604 259.5,291.5C 269.792,290.427 279.792,288.094 289.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#fff",
    d: "M 413.5,287.5 C 425.358,298.269 437.024,309.269 448.5,320.5C 448.5,334.833 448.5,349.167 448.5,363.5C 436.92,353.423 425.753,342.757 415,331.5C 414.809,333.708 414.309,335.708 413.5,337.5C 413.5,320.833 413.5,304.167 413.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 63.5,299.5 C 74.5875,310.926 86.2542,321.593 98.5,331.5C 98.5,344.167 98.5,356.833 98.5,369.5C 86.1716,358.838 74.5049,347.505 63.5,335.5C 63.5,323.5 63.5,311.5 63.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 448.5,363.5 C 448.5,376.167 448.5,388.833 448.5,401.5C 437.135,390.134 425.469,379.134 413.5,368.5C 413.5,358.167 413.5,347.833 413.5,337.5C 414.309,335.708 414.809,333.708 415,331.5C 425.753,342.757 436.92,353.423 448.5,363.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#fff",
    d: "M 63.5,335.5 C 74.5049,347.505 86.1716,358.838 98.5,369.5C 98.2017,381.835 97.8684,394.168 97.5,406.5C 85.8333,395.167 74.1667,383.833 62.5,372.5C 63.2525,360.181 63.5858,347.848 63.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#fff",
    d: "M 413.5,368.5 C 425.469,379.134 437.135,390.134 448.5,401.5C 448.5,413.833 448.5,426.167 448.5,438.5C 437.505,427.672 426.339,417.006 415,406.5C 414.814,403.964 414.314,401.631 413.5,399.5C 413.5,389.167 413.5,378.833 413.5,368.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#fff",
    d: "M 263.5,373.5 C 263.389,374.117 263.056,374.617 262.5,375C 295.333,407.167 328.167,439.333 361,471.5C 361.464,472.094 361.631,472.761 361.5,473.5C 328.167,453.5 294.833,433.5 261.5,413.5C 261.631,412.761 261.464,412.094 261,411.5C 251.298,401.965 241.798,392.298 232.5,382.5C 238.433,378.43 244.766,374.93 251.5,372C 255.695,371.191 259.695,371.691 263.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#fff",
    d: "M 62.5,372.5 C 74.1667,383.833 85.8333,395.167 97.5,406.5C 97.5,418.833 97.5,431.167 97.5,443.5C 86.1353,432.134 74.4687,421.134 62.5,410.5C 62.5,397.833 62.5,385.167 62.5,372.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#fff",
    d: "M 263.5,373.5 C 295.868,392.345 327.868,411.678 359.5,431.5C 359.062,431.435 358.728,431.601 358.5,432C 385.367,458.034 412.033,484.201 438.5,510.5C 437.833,510.5 437.5,510.833 437.5,511.5C 433.167,511.5 428.833,511.5 424.5,511.5C 403.702,498.596 382.702,485.93 361.5,473.5C 361.631,472.761 361.464,472.094 361,471.5C 328.167,439.333 295.333,407.167 262.5,375C 263.056,374.617 263.389,374.117 263.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 232.5,382.5 C 241.798,392.298 251.298,401.965 261,411.5C 261.464,412.094 261.631,412.761 261.5,413.5C 259.277,411.221 256.611,410.388 253.5,411C 247.139,414.845 240.806,418.678 234.5,422.5C 225.527,414.194 216.86,405.527 208.5,396.5C 216.5,391.833 224.5,387.167 232.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fff",
    d: "M 208.5,396.5 C 216.86,405.527 225.527,414.194 234.5,422.5C 225.407,428.261 216.074,433.594 206.5,438.5C 197.833,430.5 189.5,422.167 181.5,413.5C 190.295,407.597 199.295,401.931 208.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fff",
    d: "M 413.5,399.5 C 414.314,401.631 414.814,403.964 415,406.5C 426.339,417.006 437.505,427.672 448.5,438.5C 448.5,450.833 448.5,463.167 448.5,475.5C 436.899,465.402 425.733,454.735 415,443.5C 414.802,445.382 414.302,447.048 413.5,448.5C 413.5,432.167 413.5,415.833 413.5,399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#fff",
    d: "M 62.5,410.5 C 74.4687,421.134 86.1353,432.134 97.5,443.5C 97.1703,449.868 97.5037,456.202 98.5,462.5C 102.061,460.221 105.727,458.221 109.5,456.5C 118.779,464.111 127.446,472.445 135.5,481.5C 126.673,487.082 117.673,492.415 108.5,497.5C 92.8636,483.198 77.5302,468.531 62.5,453.5C 62.5,439.167 62.5,424.833 62.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fff",
    d: "M 181.5,413.5 C 189.5,422.167 197.833,430.5 206.5,438.5C 198.873,443.987 190.873,448.987 182.5,453.5C 181.118,450.606 179.118,448.106 176.5,446C 169.942,439.935 163.275,434.102 156.5,428.5C 164.328,422.749 172.661,417.749 181.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 156.5,428.5 C 163.275,434.102 169.942,439.935 176.5,446C 179.118,448.106 181.118,450.606 182.5,453.5C 174.742,458.593 166.742,463.26 158.5,467.5C 158.631,466.761 158.464,466.094 158,465.5C 149.938,457.27 141.772,449.27 133.5,441.5C 141.032,436.902 148.698,432.568 156.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fff",
    d: "M 359.5,431.5 C 377.276,441.558 394.942,451.891 412.5,462.5C 413.493,457.88 413.827,453.214 413.5,448.5C 414.302,447.048 414.802,445.382 415,443.5C 425.733,454.735 436.899,465.402 448.5,475.5C 448.666,483.507 448.5,491.507 448,499.5C 446.431,504.567 443.264,508.234 438.5,510.5C 412.033,484.201 385.367,458.034 358.5,432C 358.728,431.601 359.062,431.435 359.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#fff",
    d: "M 133.5,441.5 C 141.772,449.27 149.938,457.27 158,465.5C 158.464,466.094 158.631,466.761 158.5,467.5C 151.036,472.403 143.369,477.07 135.5,481.5C 127.446,472.445 118.779,464.111 109.5,456.5C 117.464,451.514 125.464,446.514 133.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#fff",
    d: "M 62.5,453.5 C 77.5302,468.531 92.8636,483.198 108.5,497.5C 100.967,502.431 93.3006,507.098 85.5,511.5C 81.8333,511.5 78.1667,511.5 74.5,511.5C 68.8785,509.376 65.0451,505.376 63,499.5C 62.5001,484.17 62.3334,468.837 62.5,453.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/Favorite.fafa61dadf484c7c287cb46d214ee4b9.svg";
export { ForwardRef as ReactComponent };